import React, { useState } from 'react'
import CarouselUpload from './CarouselUpload'
import LabImagesUpload from './LabImagesUpload'
import "./facultyScreens.css"

const CurouselLab = () => {
  const [screen,setScreen] = useState("carousel")
  return (
    <div>
      <br/>
      <div className='btn_cntr_cur'>
        <button className={screen === "carousel" ? "btn_cur_active":"btn_cur"} onClick={()=>{
          setScreen("carousel")
        }}>CAROUSEL IMAGES</button>&emsp;&emsp;
        <button className={screen === "lab" ? "btn_cur_active":"btn_cur"} onClick={()=>{
          setScreen("lab")
        }}>LAB IMAGES</button>
      </div>
      <div>
        {screen === "carousel" && <CarouselUpload/>}
        {screen === "lab" && <LabImagesUpload/>}
      </div>
    </div>
  )
}

export default CurouselLab
